import { ObservableArray, View } from "binder"
import { InvoiceDetailViewModel, InvoiceLineItem, payment } from "./invoiceDetail-viewModel"

export class InvoiceDetailView extends View<InvoiceDetailViewModel>{
    GetViewUniqueId(): string {
        return "V-F1E0BCBE-514A-44BC-AB9D-A587BE0A37BD"
    }
    loadHtml(): string {
        let element = require('./invoiceDetail.html').default;
        let style = require('./invoiceDetail.less');
        return element;
    }
    constructor() {
       super();
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName;} private _sellerName: string;
    public set cashierName(v: string) { this._cashierName = v; } public get cashierName(): string { return this._cashierName;} private _cashierName: string;
    public set receiverName(v: string) { this._receiverName = v; } public get receiverName(): string { return this._receiverName;} private _receiverName: string;
    public set invoiceNumber(v: string) { this._invoiceNumber = v; } public get invoiceNumber(): string { return this._invoiceNumber;} private _invoiceNumber: string;
    public set parentInvoiceNumber(v: string) { this._parentInvoiceNumber = v; } public get parentInvoiceNumber(): string { return this._parentInvoiceNumber;} private _parentInvoiceNumber: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;
    public set customerAccountBalance(v: number) { this._customerAccountBalance = v; } public get customerAccountBalance(): number { return this._customerAccountBalance;} private _customerAccountBalance: number;
    public set accountBalanceLabel(v: string) { this._accountBalanceLabel = v; } public get accountBalanceLabel(): string { return this._accountBalanceLabel;} private _accountBalanceLabel: string;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice;} private _totalPrice: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice;} private _finalPrice: number;
    public set totalDeficit(v: number) { this._totalDeficit = v; } public get totalDeficit(): number { return this._totalDeficit;} private _totalDeficit: number;
    public set additionCost(v: number) { this._additionCost = v; } public get additionCost(): number { return this._additionCost;} private _additionCost: number;
    public set totalAdditions(v: number) { this._totalAdditions = v; } public get totalAdditions(): number { return this._totalAdditions;} private _totalAdditions: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime;} private _creationTime: moment.Moment;
    public set invoiceType(v: number) { this._invoiceType = v; } public get invoiceType(): number { return this._invoiceType;} private _invoiceType: number;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state;} private _state: number;
    public set warehouseState(v: number) { this._warehouseState = v; } public get warehouseState(): number { return this._warehouseState;} private _warehouseState: number;
    public set payments(v: ObservableArray<payment>) { this._payments = v; } public get payments(): ObservableArray<payment> { return this._payments;} private _payments: ObservableArray<payment>;
    public set paymentState(v: number) { this._paymentState = v; } public get paymentState(): number { return this._paymentState;} private _paymentState: number;
    public set isPrinted(v: boolean) { this._isPrinted = v; } public get isPrinted(): boolean { return this._isPrinted;} private _isPrinted: boolean;
    public set canConfirm(v: boolean) { this._canConfirm = v; } public get canConfirm(): boolean { return this._canConfirm;} private _canConfirm: boolean;
    public set canCancel(v: boolean) { this._canCancel = v; } public get canCancel(): boolean { return this._canCancel;} private _canCancel: boolean;
    public set canReturn(v: boolean) { this._canReturn = v; } public get canReturn(): boolean { return this._canReturn;} private _canReturn: boolean;
    public set canPay(v: boolean) { this._canPay = v; } public get canPay(): boolean { return this._canPay;} private _canPay: boolean;
    public set canPrint(v: boolean) { this._canPrint = v; } public get canPrint(): boolean { return this._canPrint;} private _canPrint: boolean;
    public set lineItems(v: ObservableArray<InvoiceLineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<InvoiceLineItem> { return this._lineItems;} private _lineItems: ObservableArray<InvoiceLineItem>;    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set confirmationTime(v: moment.Moment) { this._confirmationTime = v; } public get confirmationTime(): moment.Moment { return this._confirmationTime;} private _confirmationTime: moment.Moment;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit;} private _canEdit: boolean;

    showPayment() {
        this.dataContext.showPayment();
    }

    printInvoice() {
        this.dataContext.printInvoice();
    }

    showEditForm() {
        this.dataContext.showEditForm();
    }

    returnInvoice() {
        this.dataContext.createReturnInvoice();
    }

    confirm() {
        this.dataContext.confirm();
    }

    cancel() {
        this.dataContext.cancel();
    }

    back() {
        this.dataContext.back();
    }

    closePopup() {
        this.dataContext.closePopup();   
    }
}
